// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/constant-speed-prop-handling.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/constant-speed-prop-handling/constant-speed-prop-handling.js';

mount([g0]);
